module.exports = __webpack_public_path__ + "img/jj.97baabfd.png";